import React from "react";
import Svg, { Path, G, Defs, ClipPath } from "react-native-svg";

function ProductRequest(props) {
  return (
    <Svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M27.1565 10.4436L10.3628 19.6652L25.0003 27.7028L41.794 18.4812L27.1565 10.4436Z"
        fill="#44A0E3"
      />
      <Path
        d="M10.8501 38.9095L25.0101 46.6849V27.7023L10.8501 19.9269V38.9095Z"
        fill="#178DE3"
      />
      <Path
        d="M42.3372 37.2222V19.2715L32.125 33.0668L28.5625 31.3324L28.5728 44.7804L42.3372 37.2222Z"
        fill="#178DE3"
      />
      <Path
        d="M27.7183 26.4842L33.2667 32.0323L48.0621 23.9082L42.5136 18.3601L27.7183 26.4842Z"
        fill="#88BDE3"
      />
      <Path
        d="M4.43701 25.1586L19.3536 33.3493L24.9995 27.7035L10.0829 19.5128L4.43701 25.1586Z"
        fill="#88BDE3"
      />
      <Path
        d="M42.3366 18.1838L48.0242 12.4969L33.3498 4.43872L27.6621 10.1264L42.3366 18.1838Z"
        fill="#88BDE3"
      />
      <Path
        d="M5.03076 11.2397L10.4463 16.6548L24.9996 8.66371L19.584 3.24854L5.03076 11.2397Z"
        fill="#88BDE3"
      />
      <Path
        d="M43.6633 18.1826L48.7254 13.1204C48.9342 12.9121 49.0323 12.6173 48.9906 12.3254C48.9492 12.0335 48.7723 11.7779 48.5137 11.6358L42.428 8.29413C41.9743 8.0451 41.4045 8.211 41.1551 8.66473C40.9061 9.11884 41.0716 9.68866 41.5257 9.93769L46.5164 12.6781L42.1721 17.0221L26.5469 8.44208L30.8909 4.09807L35.2821 6.50957C35.7359 6.7586 36.3061 6.59307 36.5551 6.13897C36.8045 5.68523 36.6386 5.11504 36.1845 4.86601L31.1765 2.11576C30.8111 1.91508 30.357 1.9799 30.0625 2.2747L25 7.33721L19.9375 2.2747C19.6427 1.9799 19.1886 1.91544 18.8235 2.11576L1.48625 11.6358C1.22771 11.7779 1.05083 12.0332 1.00944 12.3254C0.967696 12.6173 1.06584 12.9121 1.27458 13.1204L6.33673 18.1826L1.27458 23.2444C1.06584 23.4531 0.967696 23.7475 1.00944 24.0398C1.05083 24.3317 1.22771 24.5873 1.48625 24.729L6.72528 27.606V37.222C6.72528 37.5644 6.91168 37.8793 7.21161 38.0441L24.5488 47.5638C24.6895 47.6411 24.8447 47.6795 25 47.6795C25.1553 47.6795 25.3105 47.6411 25.4512 47.5638L42.7884 38.0441C43.0883 37.8793 43.2747 37.5644 43.2747 37.222V27.606L48.5137 24.7294C48.7723 24.5873 48.9492 24.3317 48.9906 24.0398C49.0323 23.7479 48.9342 23.4531 48.7254 23.2447L43.6633 18.1826ZM25 26.6326L9.61067 18.1822L25 9.73151L40.3893 18.1822L25 26.6326ZM19.1095 4.09807L23.4531 8.44208L7.82795 17.0221L3.48394 12.6781L19.1095 4.09807ZM7.82868 19.3427L23.4539 27.9227L19.1095 32.2671L3.48394 23.6871L7.82868 19.3427ZM41.3997 36.6675L25.9375 45.1578V35.5744C25.9375 35.0565 25.5178 34.6369 25 34.6369C24.4822 34.6369 24.0625 35.0565 24.0625 35.5744V45.1578L8.60029 36.6675V28.6357L18.8235 34.2494C18.9652 34.327 19.1205 34.3651 19.2743 34.3651C19.5171 34.3651 19.7573 34.2706 19.9375 34.0905L25 29.028L30.0625 34.0905C30.2427 34.271 30.4829 34.3651 30.7257 34.3651C30.8795 34.3651 31.0348 34.327 31.1765 34.2494L41.3997 28.6357V36.6675ZM30.8909 32.2671L26.5465 27.9224L42.1717 19.3427L46.5164 23.6868L30.8909 32.2671Z"
        fill="#00487D"
      />
      <Path
        d="M38.9502 8.39185C39.1967 8.39185 39.4376 8.29151 39.613 8.11683C39.7874 7.94251 39.8877 7.70081 39.8877 7.45435C39.8877 7.20752 39.7874 6.96582 39.613 6.7915C39.4387 6.61682 39.1967 6.51685 38.9502 6.51685C38.7026 6.51685 38.4617 6.61682 38.2874 6.7915C38.1119 6.96582 38.0127 7.20752 38.0127 7.45435C38.0127 7.70081 38.1119 7.94251 38.2874 8.11683C38.4617 8.29151 38.7037 8.39185 38.9502 8.39185Z"
        fill="#00487D"
      />
      <Path
        d="M25 31.5242C24.7535 31.5242 24.5115 31.6242 24.3372 31.7989C24.1628 31.9739 24.0625 32.2149 24.0625 32.4617C24.0625 32.7089 24.1628 32.9499 24.3372 33.1253C24.5115 33.2996 24.7535 33.3992 25 33.3992C25.2465 33.3992 25.4885 33.2996 25.6628 33.1253C25.8372 32.9499 25.9375 32.7089 25.9375 32.4617C25.9375 32.2149 25.8372 31.9739 25.6628 31.7989C25.4885 31.6242 25.2465 31.5242 25 31.5242Z"
        fill="#00487D"
      />
    </Svg>
  );
}

export default ProductRequest;
